import { useDispatch, useSelector } from 'react-redux';
import { useMemo } from 'react';
import {
    setSelectedMyDayPlanDate,
    setSelectedReminderDate,
    setSelectedStatusNextStepDate,
    setNote,
    setNotesText,
    setMyDayDate,
    setDeadlineDate,
    setIsMyDayChecked,
    setIsDeadlineChecked,
    resetTaskData
} from '../Redux/slice';
import axios from 'axios';
import { useNavigate } from 'react-router-dom';

export const useTaskData = () => {
    const dispatch = useDispatch();
    const navigate = useNavigate();

    const taskDataSelector = useMemo(() => (state) => ({
        selectedMyDayPlanDate: state.redux.selectedMyDayPlanDate,
        selectedReminderDate: state.redux.selectedReminderDate,
        selectedStatusNextStepDate: state.redux.selectedStatusNextStepDate,
        notes: state.redux.note,
        notesText: state.redux.notesText,
        myDayDate: state.redux.myDayDate,
        deadlineDate: state.redux.deadlineDate,
        isMyDayChecked: state.redux.isMyDayChecked,
        isDeadlineChecked: state.redux.isDeadlineChecked,
    }), []);

    const taskData = useSelector(taskDataSelector);

    const updateSelectedMyDayPlanDate = (date) => {
        dispatch(setSelectedMyDayPlanDate(date));
    };

    const updateSelectedReminderDate = (date) => {
        dispatch(setSelectedReminderDate(date));
    };

    const updateSelectedStatusNextStepDate = (date) => {
        dispatch(setSelectedStatusNextStepDate(date));
    };

    const updateNote = (note) => {
        dispatch(setNote(note));
    };

    const updateNotesText = (text) => {
        dispatch(setNotesText(text));
    };

    const updateMyDayDate = (date) => {
        dispatch(setMyDayDate(date));
    };

    const updateDeadlineDate = (date) => {
        dispatch(setDeadlineDate(date));
    };

    const updateIsMyDayChecked = (checked) => {
        dispatch(setIsMyDayChecked(checked));
    };

    const updateIsDeadlineChecked = (checked) => {
        dispatch(setIsDeadlineChecked(checked));
    };

    const handleDateSelect = (date, type) => {
        switch (type) {
            case 'myDay':
                updateSelectedMyDayPlanDate(date);
                updateMyDayDate(date);
                break;
            case 'reminder':
                updateSelectedReminderDate(date);
                break;
            case 'statusNextStep':
                updateSelectedStatusNextStepDate(date);

                break;
            case 'deadline':
                updateDeadlineDate(date);
                break;
            default:
                break;
        }
    };


    const handleUpdateTask = async (newDate, type = 'reminder', taskItem) => {

        if (!taskItem?.id) {
            console.error('TaskStatusNextStep - No task ID provided');
            return;
        }

        const data = {};

        switch (type) {
            case 'myDay':
                data.myDayPlan = newDate;
                break;
            case 'reminder':
                data.reminder = newDate;
                break;
            case 'statusNextStep':
                data.nextStep = newDate;

                data.notes = taskData.notes;

                break;
            case 'deadline':
                data.deadline = newDate;
                break;
            default:
                console.warn('TaskStatusNextStep - Unknown type:', type);
                break;
        }


        try {

            const response = await axios.put(
                `${process.env.REACT_APP_BACKEND_URL}/task/updateTask/${taskItem.id}`,
                data
            );


            if (response.status === 200) {
                handleDateSelect(newDate, type);


                if (type === 'myDay') {
                    updateMyDayDate(newDate);
                    updateSelectedMyDayPlanDate(newDate);
                }

                return response.data;
            }
        } catch (error) {
            if (error?.response?.status === 401) {
                localStorage.clear();
                navigate('/login');
            }
            console.error('TaskStatusNextStep - Error updating task:', error);
            throw error;
        }
    };

    const resetAllTaskData = () => {
        dispatch(resetTaskData());
    };

    return {
        ...taskData,
        updateSelectedMyDayPlanDate,
        updateSelectedReminderDate,
        updateSelectedStatusNextStepDate,
        updateNote,
        updateNotesText,
        updateMyDayDate,
        updateDeadlineDate,
        updateIsMyDayChecked,
        updateIsDeadlineChecked,
        handleDateSelect,
        handleUpdateTask,
        resetAllTaskData,
    };
};
